import React from "react";
import { ArrowUpRightIcon } from "../../icons";

const formatPrice = (price) => {
  if (price >= 1) {
    return price.toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }
  return `$${price.toFixed(4)}`;
};

const NewsTicker = ({ marketPrices = [] }) => {
  if (!marketPrices?.length) return null;

  // Render a single ticker item
  const renderItem = (coin, index) => {
    const isPositive = (coin.price_change_percentage_24h ?? 0) >= 0;
    const changeAbs = Math.abs(coin.price_change_percentage_24h ?? 0).toFixed(1);

    return (
      <div
        key={`${coin.id}-${index}`}
        className="flex shrink-0 items-center gap-2 border-r border-divider/40 px-5 text-sm font-medium"
      >
        {/* Token Image */}
        <img
          src={coin.image}
          alt={coin.name}
          className="size-5 rounded-full object-contain"
          loading="lazy"
        />

        {/* Token Name & Symbol */}
        <div className="flex items-center gap-1.5 whitespace-nowrap">
          <span className="font-semibold text-text-primary">{coin.name}</span>
          <span className="text-sm uppercase text-text-secondary">
            {coin.symbol}
          </span>
        </div>

        {/* Current Price */}
        <span className="text-text-primary whitespace-nowrap">
          {formatPrice(coin.current_price ?? 0)}
        </span>

        {/* 24h Change Badge */}
        <span
          className={`flex items-center text-xs font-semibold whitespace-nowrap ${
            isPositive ? "text-[#4AB932]" : "text-[#EF4444]"
          }`}
        >
          {/* {isPositive ? "▲" : "▼"} {changeAbs}% */}
          <span className={isPositive ? "" : "rotate-180"}>
            <ArrowUpRightIcon />
          </span> 
          {changeAbs}%
        </span>
      </div>
    );
  };

  return (
    <div className="relative w-full overflow-hidden bg-background py-2">
      {/* Edge gradient fades */}
      <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-8 bg-gradient-to-r from-background to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-8 bg-gradient-to-l from-background to-transparent" />

      {/* Infinite scrolling track (paused on hover) */}
      <div className="flex w-max animate-ticker hover:[animation-play-state:paused]">
        {/* Duplicate list to achieve a seamless loop */}
        {marketPrices.map((coin, index) => renderItem(coin, `primary-${index}`))}
        {marketPrices.map((coin, index) => renderItem(coin, `duplicate-${index}`))}
      </div>
    </div>
  );
};

export default NewsTicker;